import { borderColor } from '../../Utilities/utils/Theming';
import { focusRingNoGap } from '../../Themes/base/focusRing';

export const rootStyle = (size = 'default') => {
	return {
		fontSize: 'var(--epods--font-size-p)',
		fontFamily: 'var(--epods--font-base)',
		color: 'var(--epods--color-text-primary)',
		zIndex: 'var(--epods--zindex-dropdown)',
		width: 'auto',
		height: 'var(--epods--input-' + size + '-height)',
	};
};

export const dropdownStatusStyle = (
	$error: boolean,
	warning: boolean,
	$positive: boolean,
	$isFocused: boolean,
	$disabled: boolean,
	$theme: any,
	readOnly: any,
) => {
	const focusCrtl = $isFocused
		? {
				...focusRingNoGap,
		  }
		: {};

	const errorCrtl = $error
		? {
				backgroundColor: 'var(--epods--color-signal-error-bg)',
				...borderColor('var(--epods--color-signal-error-border)'),
		  }
		: {};

	const warningCrtl = warning
		? {
				backgroundColor: 'var(--epods--color-signal-warning-bg)',
				...borderColor('var(--epods--color-signal-warning-border)'),
		  }
		: {};

	const positiveCrtl = $positive
		? {
				backgroundColor: 'var(--epods--color-signal-success-bg)',
				...borderColor('var(--epods--color-signal-success-border)'),
		  }
		: {};

	const readonlyCtrl = readOnly
		? {
				backgroundColor: 'var(--epods--color-bg-input-readonly)',
				...borderColor('var(--epods--color-border)'),
		  }
		: {};

	const defaultCrtl = {
		backgroundColor: 'var(--epods--color-bg-input)',
		...borderColor($disabled ? 'var(--epods--color-border-light)' : 'var(--epods--color-border)'),
		borderWidth: '1px',
		height: 'inherit',

		':hover': {
			...borderColor($disabled ? 'var(--epods--color-border-light)' : 'var(--epods--color-border-active)'),
		},
	};
	return {
		...defaultCrtl,
		...positiveCrtl,
		...errorCrtl,
		...warningCrtl,
		...readonlyCtrl,
		...focusCrtl,
	};
};

export const singleValueSizesStyle = (size = 'default') => {
	return {
		fontSize: 'var(--epods--phone-dropdown-' + size + '-font-size)',
		fontFamily: 'var(--epods--font-base)',
		height: 'auto',
		color: 'var(--epods--color-text-primary)',
	};
};
